module.exports = __webpack_public_path__ + "static/img/open_code.9434365d.jpg";